// Generated by Melange

import * as Curry from "melange.js/curry.jsx";

function let$star(a, f) {
  return a.then(Curry.__1(f));
}

function and$star(a, b) {
  return Promise.all([
    a,
    b
  ]);
}

const Monad_syntax = {
  let$star: let$star,
  and$star: and$star
};

export {
  Monad_syntax,
}
/* No side effect */
